"use client";
import { Stack, Table, Box, SimpleGrid } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { Heading, Text } from "@/elements";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";

type AppServicesProps = {
  heading?: string;
  desc?: string;
  headers: {
    onemind: string;
    otherCompanies: string;
  };
  data: {
    feature: string;
    onemind: string;
    otherCompanies: string;
  }[];
};

const ServicesComparsion = (props: AppServicesProps) => {
  const { heading, desc, headers, data } = props;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();

  return (
    <Stack gap={8}>
      {heading && (
        <Balancer>
          <Heading as="h2" variant={HeadingVariant} textAlign={"center"}>
            {heading}
          </Heading>
        </Balancer>
      )}
      {desc && (
        <Balancer>
          <Text variant={TextVariant} color="text.100" textAlign={"center"}>
            {desc}
          </Text>
        </Balancer>
      )}
      <Box overflowX="auto" w="100%" maxW="100%">
        <Table.Root
          striped
          display={{ base: "none", md: "table" }}
          boxShadow={"xl"}
          borderColor={"rgb(237,242,247)"}
          borderWidth={"2px"}
          w="100%"
          minW="100%"
        >
          <Table.Header>
            <Table.Row w="100%">
              <Table.ColumnHeader
                color="black"
                fontSize="23px"
                py={6}
                textTransform={"none"}
              >
                Feature
              </Table.ColumnHeader>
              <Table.ColumnHeader
                backgroundColor={"#3182ce"}
                color="white"
                fontSize="23px"
                py={6}
                textTransform={"none"}
                border="0px"
                className="brand-shadow"
              >
                {headers.onemind}
              </Table.ColumnHeader>
              <Table.ColumnHeader
                color="black"
                fontSize="23px"
                py={6}
                textTransform={"none"}
              >
                {headers.otherCompanies}
              </Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.map((item, index) => (
              <Table.Row
                key={index}
                bg="transparent !important"
                _hover={{ bg: "transparent !important" }}
              >
                <Table.Cell fontWeight={600} fontSize={"17px"}>
                  {item.feature}
                </Table.Cell>
                <Table.Cell
                  whiteSpace="normal"
                  bg="#3182ce !important"
                  color="white"
                  fontSize={"18px"}
                  fontWeight={550}
                  zIndex={1}
                  border="1px solid rgba(255, 255, 255, 0.3) !important"
                  _hover={{
                    bg: "#3182ce !important",
                  }}
                >
                  {item.onemind}
                </Table.Cell>
                <Table.Cell whiteSpace="normal" fontSize={"17px"}>
                  {item.otherCompanies}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Box>

      <Stack display={{ base: "flex", md: "none" }} gap={4}>
        {data.map((item, index) => (
          <Box key={index} p={4} borderWidth="1px" borderRadius="md" boxShadow="md">
            <Text fontSize="lg" fontWeight="bold" mb={2}>
              {item.feature}
            </Text>
            <SimpleGrid columns={{ base: 1, sm: 2 }} gap={4}>
              <Box>
                <Text fontSize="md" fontWeight="bold" color="gray.500">
                  {headers.onemind}
                </Text>
                <Text
                  variant={TextVariant}
                  mt={1}
                  p={2}
                  bg="#3182ce"
                  color="white"
                  borderRadius="md"
                >
                  {item.onemind}
                </Text>
              </Box>
              <Box>
                <Text fontSize="md" fontWeight="bold" color="gray.500">
                  {headers.otherCompanies}
                </Text>
                <Text variant={TextVariant} mt={1} p={2} bg="gray.100" borderRadius="md">
                  {item.otherCompanies}
                </Text>
              </Box>
            </SimpleGrid>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default ServicesComparsion;
